import { storyblokHome } from '@/config';

const getPartners = async () => {
  const { data } = await storyblokHome.get('/stories?content_type=Partner&sort_by=created_at:asc');
  return data.stories;
};

export default getPartners;
